"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RobotoLightFont = exports.RobotoRegularFont = exports.RobotoMediumFont = exports.RobotoBoldFont = void 0;

require("core-js/modules/es.array.concat.js");

var _RobotoBold = _interopRequireDefault(require("../assets/fonts/Roboto-Bold.eot"));

var _RobotoBold2 = _interopRequireDefault(require("../assets/fonts/Roboto-Bold.woff2"));

var _RobotoBold3 = _interopRequireDefault(require("../assets/fonts/Roboto-Bold.woff"));

var _RobotoBold4 = _interopRequireDefault(require("../assets/fonts/Roboto-Bold.ttf"));

var _RobotoMedium = _interopRequireDefault(require("../assets/fonts/Roboto-Medium.eot"));

var _RobotoMedium2 = _interopRequireDefault(require("../assets/fonts/Roboto-Medium.woff2"));

var _RobotoMedium3 = _interopRequireDefault(require("../assets/fonts/Roboto-Medium.woff"));

var _RobotoMedium4 = _interopRequireDefault(require("../assets/fonts/Roboto-Medium.ttf"));

var _RobotoRegular = _interopRequireDefault(require("../assets/fonts/Roboto-Regular.eot"));

var _RobotoRegular2 = _interopRequireDefault(require("../assets/fonts/Roboto-Regular.woff2"));

var _RobotoRegular3 = _interopRequireDefault(require("../assets/fonts/Roboto-Regular.woff"));

var _RobotoRegular4 = _interopRequireDefault(require("../assets/fonts/Roboto-Regular.ttf"));

var _RobotoLight = _interopRequireDefault(require("../assets/fonts/Roboto-Light.eot"));

var _RobotoLight2 = _interopRequireDefault(require("../assets/fonts/Roboto-Light.woff2"));

var _RobotoLight3 = _interopRequireDefault(require("../assets/fonts/Roboto-Light.woff"));

var _RobotoLight4 = _interopRequireDefault(require("../assets/fonts/Roboto-Light.ttf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* Roboto Bold */

/* Roboto Medium */

/* Roboto Regular */

/* Roboto Light */
var RobotoBoldFont = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 700,
  fontDisplay: 'swap',
  src: "\n    local('Roboto Bold'),\n    local('Roboto-Bold'),\n    url(".concat(_RobotoBold["default"], "?#iefix) format('embedded-opentype'),\n    url(").concat(_RobotoBold2["default"], ") format('woff2'),\n    url(").concat(_RobotoBold3["default"], ") format('woff'),\n    url(").concat(_RobotoBold4["default"], ") format('truetype')\n  ")
};
exports.RobotoBoldFont = RobotoBoldFont;
var RobotoMediumFont = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 500,
  fontDisplay: 'swap',
  src: "\n    local('Roboto Medium'),\n    local('Roboto-Medium'),\n    url(".concat(_RobotoMedium["default"], "?#iefix) format('embedded-opentype'),\n    url(").concat(_RobotoMedium2["default"], ") format('woff2'),\n    url(").concat(_RobotoMedium3["default"], ") format('woff'),\n    url(").concat(_RobotoMedium4["default"], ") format('truetype')\n  ")
};
exports.RobotoMediumFont = RobotoMediumFont;
var RobotoRegularFont = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontDisplay: 'swap',
  src: "\n    local('Roboto'),\n    local('Roboto-Regular'),\n    url(".concat(_RobotoRegular["default"], "?#iefix) format('embedded-opentype'),\n    url(").concat(_RobotoRegular2["default"], ") format('woff2'),\n    url(").concat(_RobotoRegular3["default"], ") format('woff'),\n    url(").concat(_RobotoRegular4["default"], ") format('truetype')\n  ")
};
exports.RobotoRegularFont = RobotoRegularFont;
var RobotoLightFont = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 300,
  fontDisplay: 'swap',
  src: "\n    local('Roboto Light'),\n    local('Roboto-Light'),\n    url(".concat(_RobotoLight["default"], "?#iefix) format('embedded-opentype'),\n    url(").concat(_RobotoLight2["default"], ") format('woff2'),\n    url(").concat(_RobotoLight3["default"], ") format('woff'),\n    url(").concat(_RobotoLight4["default"], ") format('truetype')\n  ")
};
exports.RobotoLightFont = RobotoLightFont;